export const blackListedCountryCodes = [
    'AL',
    'BB',
    'BF',
    'BI',
    'BW',
    'BY',
    'BU',
    'CF',
    'CU',
    'HT',
    'IQ',
    'IR',
    'JM',
    'KH',
    'KP',
    'KY',
    'LB',
    'LY',
    'MA',
    'ML',
    'MT',
    'MU',
    'NI',
    'PK',
    'RU',
    'SD',
    'SN',
    'SO',
    'SS',
    'SY',
    'UA',
    'UG',
    'VE',
    'YE',
    'ZW',
    'CD',
    'CG',
    'MM',
];

export const RESERVED_SUBDOMAINS = [
    'www',
    'admin',
    'api',
    'uat',
    'qa',
    'staging',
    'prod',
    'production',
    'dev',
    'development',
    'test',
    'mail',
    'smtp',
    'ftp',
    'ssh',
    'vpn',
    'cdn',
    'static',
    'assets',
    'app',
];

export const DYNAMIC_FIELD_AUTO_POPULATE_HINT =
    'This field is pre-filled automatically with data from the logged-in user.';

export const DYNAMIC_FIELD_VALUE_MAPPING_HINT =
    'This field’s value is translated to a different value before being saved.';

export const BACKGROUND_CUSTOMIZATION_DESCRIPTIONS = {
    title: 'Background Customization',
    description: 'Pick the background color displayed behind input fields on the shipment and search forms.',
};
